import { forwardRef } from "react";
import { Icon } from "@newsela/angelou";
import ThinArrowDownSvg from "./ThinArrowDown.svg.jsx";

const ThinArrowDown = forwardRef<SVGSVGElement, any>((props, ref) => {
  return <Icon ref={ref} SvgComponent={ThinArrowDownSvg} {...props} />;
});

ThinArrowDown.displayName = "ThinArrowDown";
export default ThinArrowDown;
